import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { __rest } from "tslib";
import React, { Component } from 'react';
import LabelAndHint from '../LabelAndHint/LabelAndHint';
var NewButtonGroup = /*#__PURE__*/function (_Component) {
  function NewButtonGroup() {
    var _this;
    _classCallCheck(this, NewButtonGroup);
    _this = _callSuper(this, NewButtonGroup, arguments);
    _this.state = {
      selectedItems: _this.props.initialSelectedItems
    };
    _this.getButtonProps = function (_a) {
      var item = _a.item,
        rest = __rest(_a, ["item"]);
      return Object.assign(Object.assign({
        disabled: _this.props.disabled
      }, rest), {
        onClick: function onClick() {
          return _this.selectItem(item);
        }
      });
    };
    _this.getNewButtonGroupStateAndHelpers = function () {
      return {
        getButtonProps: _this.getButtonProps,
        onStateChange: _this.props.onStateChange,
        selectedItems: _this.state.selectedItems
      };
    };
    _this.selectItem = function (item) {
      var selectedItems = _this.state.selectedItems;
      var _this$props = _this.props,
        disabled = _this$props.disabled,
        onStateChange = _this$props.onStateChange,
        type = _this$props.type,
        limit = _this$props.limit;
      if (disabled) {
        return;
      }
      var itemIndex = selectedItems.findIndex(function (si) {
        return si.key === item.key;
      });
      var newSelectedItems;
      if (type === 'multiple' && itemIndex === -1 && limit > 0 && selectedItems.length >= limit) {
        return;
      }
      switch (type) {
        case 'multiple':
          newSelectedItems = itemIndex >= 0 ? selectedItems.filter(function (si) {
            return si.key !== item.key;
          }) : [].concat(_toConsumableArray(selectedItems), [item]);
          break;
        case 'single_with_default':
          newSelectedItems = itemIndex >= 0 ? _this.props.initialSelectedItems : [item];
          break;
        default:
          newSelectedItems = itemIndex >= 0 ? [] : [item];
          break;
      }
      _this.setState({
        selectedItems: newSelectedItems
      }, function () {
        return onStateChange(_this.state);
      });
    };
    _this.renderProp = function () {
      var children = _this.props.children;
      var renderProp = Array.isArray(children) ? children[0] : children;
      return renderProp(_this.getNewButtonGroupStateAndHelpers());
    };
    return _this;
  }
  _inherits(NewButtonGroup, _Component);
  return _createClass(NewButtonGroup, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        errorText = _this$props2.errorText,
        label = _this$props2.label;
      return /*#__PURE__*/React.createElement(LabelAndHint, {
        errorText: errorText,
        label: label,
        highlightInput: false,
        render: this.renderProp
      });
    }
  }]);
}(Component);
NewButtonGroup.defaultProps = {
  disabled: false,
  errorText: '',
  initialSelectedItems: [],
  label: '',
  type: 'single',
  limit: 0
};
export default NewButtonGroup;